<template>
  <gmap-marker
    v-if="showLocation"
    :position="currentPosition"
    icon="images/icons/marker--current-location.png"
  >
  </gmap-marker>
</template>

<script>
export default {
  data() {
    return {
      watchPositionIdentifier: null
    }
  },
  computed: {
    showLocation() {
      return this.$store.state.showLocation;
    },
    currentPosition() {
      return this.$store.state.currentPosition;
    }
  },
  beforeDestroy() {
    navigator.geolocation.clearWatch(this.watchPositionIdentifier);
    this.watchPositionIdentifier = null;
  },
  mounted() {
    if(!this.showLocation) {
      this.$store.dispatch("setCurrentPosition", {
        lat: 0.0,
        lng: 0.0
      });
      navigator.geolocation.clearWatch(this.watchPositionIdentifier);
      this.watchPositionIdentifier = null;
    } else {
      // show current location. also enable watching location
      if (navigator.geolocation) {
        // watch location
        this.watchPositionIdentifier = navigator.geolocation.watchPosition(
          this.setLocationMarker,
          this.handleLocationError,
          {enableHighAccuracy: true}
        )
      } else {
        // browser doesn't support Geolocation
        alert('sorry, this browser might not support geolocation')
        this.$store.dispatch("toggleShowLocation");
      }
    }
  },
  methods: {
    setLocationMarker: function(position) {
      this.$store.dispatch("setCurrentPosition", {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
    },
    handleLocationError: function() {
      this.$store.dispatch("setCurrentPosition", {
        lat: 0.0,
        lng: 0.0
      });
    }
  }
};
</script>
